const { logError } = require('../logger');

const UseAbility = function (actor, abilityHandle, staticTarget, stance) {
  this.query = (target) => {
    try {
      if (!target && !staticTarget) {
        return null;
      }

      return {
        actorId: actor.uid,
        abilityHandle,
        victimId: target ? target.uid : staticTarget.uid,
        stance,
      };
    } catch (err) {
      logError(err, {
        module: 'UseAbility',
        func: 'query',
        actor,
        abilityHandle,
        staticTarget,
      });
    }
  };
};
module.exports = UseAbility;
